export function hexToHsl(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || "");
  if (!m) return { h: 200, s: 70, l: 45 };
  const [r, g, b] = [m[1], m[2], m[3]].map((x) => parseInt(x, 16) / 255);
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h /= 6;
  }
  return { h: Math.round(h * 360), s: Math.round(s * 100), l: Math.round(l * 100) };
}

export function brandVar(hex, dark) {
  const c = hexToHsl(hex);
  const l = dark ? Math.max(c.l, Math.min(c.l + 14, 66)) : Math.min(c.l, 48);
  return { value: `${c.h} ${c.s}% ${l}%`, fg: l > 58 ? "222 47% 9%" : "0 0% 100%" };
}

export const FONT_OPTIONS = ["Chivo", "IBM Plex Sans", "Archivo", "Libre Franklin", "Barlow", "Public Sans", "Work Sans", "Figtree", "Source Serif 4"];

export function loadFont(family) {
  if (!family) return;
  const id = `font-${family.replace(/\s+/g, "-")}`;
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${family.replace(/\s+/g, "+")}:wght@400;500;600;700;900&display=swap`;
  document.head.appendChild(link);
}
